import TextAnimation from "../animation/TextAnimation";

export default function Footer() {
  return (
    <footer className="absolute bottom-4 w-full text-center font-['Raleway'] text-[12px] font-normal text-white md:text-[16px] lg:text-[18px]">
      <TextAnimation customProps={{ delay: 0.5 }}>
        <div className="flex flex-col items-center gap-1 px-4">
          <p>Copyright 2023. Qouda.ca. All rights reserved.</p>
          <p className="text-[11px] md:text-[14px] lg:text-[16px]">93 Byng Avenue, Toronto, ON, Canada, M1L 1N8</p>
        </div>
      </TextAnimation>
    </footer>
  );
}
